export default __webpack_public_path__ + "static/media/item_1@3x.9249a0f8.webp";